/**
 * Input\Textarea\Text处理
 */

import { Input } from '@tencent/udesign/dist';
import classNames from 'classnames';
import { getAllowClearConfig, getPlaceholderConfig } from '../../../libs';
import {
  FieldType,
  FieldValueType,
  IConfigField,
  IValue,
} from '../../../model';
import { DynamicButtonLink } from './text-link';

// text input
interface IPropsText<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicText = <T,>(props: IPropsText<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;
  const filterType = fieldConfig.filter_type || FieldType.text;

  if (isFilterModeView) {
    const onChanged = (value: string) => {
      props.onChanged(fieldConfig.key, value);
    };

    const onBlur = (value: string) => {
      if (2 > 1) {
        return;
      }
      props.onChanged(fieldConfig.key, value);
    };

    const type = filterType === FieldType.text ? 'text' : 'textarea';
    const placeholder = getPlaceholderConfig(fieldConfig);

    return (
      <Input
        type={type}
        placeholder={placeholder}
        value={selectedValue.value || ''}
        icon="mdi-magnify"
        onChange={onChanged}
        onBlur={onBlur}
        className={classNames('w-140 diff-u-input', props.className)}
        allowClear={getAllowClearConfig(fieldConfig.filterOptExtension)}
      />
    );
  }

  return <span>{selectedValue.value}</span>;
};

// text 入口类型处理集合
interface IPropsTextEntry<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicTextEntry = <T,>(props: IPropsTextEntry<T>) => {
  const { selectedValue } = props;

  if (props.fieldConfig.value_type === FieldValueType.url) {
    return (
      <DynamicButtonLink
        selectedValue={selectedValue}
        className={props.className}
      />
    );
  }

  return (
    <DynamicText
      onChanged={props.onChanged}
      fieldConfig={props.fieldConfig}
      selectedValue={props.selectedValue}
      isFilterModeView={props.isFilterModeView}
      className={props.className}
    />
  );
};
